// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import type * as wasm_module_type from "../../dist/wasm/perspective-viewer.js";
import { load_wasm_stage_0 } from "@perspective-dev/client/src/ts/wasm/decompress.ts";

// @ts-ignore
import * as worker_url from "./perspective-viewer.worker";

export async function init_client(
    wasm_binary:
        | Promise<Response | ArrayBuffer | Uint8Array>
        | Response
        | ArrayBuffer
        | Uint8Array,
    wasm_module?: typeof wasm_module_type,
) {
    // @ts-ignore
    const url = await worker_url.getWorkerURL();
    if (wasm_module === undefined) {
        wasm_module = (await import(url)) as typeof wasm_module_type;
    }

    const unzipped = await load_wasm_stage_0(wasm_binary);
    const module_or_path = await WebAssembly.compile(unzipped as BufferSource);
    await wasm_module.default({ module_or_path });
    await wasm_module.init(module_or_path, url);
}
